import { Navigate, useLocation } from 'react-router-dom';
import { ERIS_Screen } from '../eris/router/ErisScreen';
import { ErisScreensMap } from '../eris/router/ErisScreenMap';
import { WaScreensMap } from '../wards/router/WardsScreenMap';
import { WA_Screen } from '../wards/router/WardsScreens';
import { WF_Screen } from '../wf/router/WfScreens';
import { WfScreensMap } from '../wf/router/WfScreensMap';

export const NOT_FOUND_PATH = '/notFound';

type BuildEnv = 'er' | 'wa' | 'wf' | 'all' | undefined;
const env = process.env.REACT_APP_BUILD_NAME as BuildEnv;

function ScreensFallback() {
  const { pathname } = useLocation();
  const isErEnabled = env === 'all' || env === 'er' || env === undefined;
  const isWaEnabled = env === 'all' || env === 'wa' || env === undefined;
  const isWfEnabled = env === 'all' || env === 'wf' || env === undefined;
  const erLogin = `/${ErisScreensMap[ERIS_Screen.Login].path}`;
  const waLogin = `/${WaScreensMap[WA_Screen.Login].path}`;
  const wfLogin = `/${WfScreensMap[WF_Screen.Login].path}`;

  if (pathname === '/') {
    if (env === 'er') return <Navigate to={erLogin} replace />;
    if (env === 'wa') return <Navigate to={waLogin} replace />;
    if (env === 'wf') return <Navigate to={wfLogin} replace />;
  }

  if (env === 'er' && (pathname === '/er' || pathname.startsWith('/er/'))) {
    const next = pathname.replace(/^\/er/, '');
    return <Navigate to={next || erLogin} replace />;
  }
  if (env === 'wa' && (pathname === '/wa' || pathname.startsWith('/wa/'))) {
    const next = pathname.replace(/^\/wa/, '');
    return <Navigate to={next || waLogin} replace />;
  }
  if (env === 'wf' && (pathname === '/wf' || pathname.startsWith('/wf/'))) {
    const next = pathname.replace(/^\/wf/, '');
    return <Navigate to={next || wfLogin} replace />;
  }

  if (isErEnabled && (pathname === '/er' || pathname.startsWith('/er/')))
    return <Navigate to={`/er/${ErisScreensMap[ERIS_Screen.Login].path}`} replace />;
  if (isWaEnabled && (pathname === '/wa' || pathname.startsWith('/wa/')))
    return <Navigate to={`/wa/${WaScreensMap[WA_Screen.Login].path}`} replace />;
  if (isWfEnabled && (pathname === '/wf' || pathname.startsWith('/wf/')))
    return <Navigate to={`/wf/${WfScreensMap[WF_Screen.Login].path}`} replace />;

  return <Navigate to={`${NOT_FOUND_PATH}`} />;
}

export default ScreensFallback;
